/**
 * 与后端约定的 type 值，三列依次为：0: 账户与管理, 1: 自助功能, 2: 证书与报告验证, 3: 会员与合作
 * titleKey 用于 i18n 展示，勿再用中文 title 做判断
 */
export const GUIDE_COLUMN_DEFS = [
  { type: '0', titleKey: 'platformGuide.column.accountManage' },
  { type: '1', titleKey: 'platformGuide.column.selfService' },
  { type: '2', titleKey: 'platformGuide.column.certVerify' },
  { type: '3', titleKey: 'platformGuide.column.memberCooperate' },
]

export function rowTypeKey(row) {
  const v = row?.type ?? row?.guideType ?? row?.categoryType ?? row?.guideCategory
  return String(v ?? '').trim()
}

export function sortGuideRows(rows) {
  return [...rows].sort((a, b) => {
    const oa = Number(a?.sortOrder ?? a?.orderNum ?? a?.sort ?? 0) || 0
    const ob = Number(b?.sortOrder ?? b?.orderNum ?? b?.sort ?? 0) || 0
    return oa - ob
  })
}

export function itemRowKey(item) {
  return item?.id != null ? String(item.id) : ''
}

export function itemDisplayName(item, unnamedLabel = '') {
  return item?.guideName || unnamedLabel
}

export function buildGuideColumns(functionGuideList) {
  return GUIDE_COLUMN_DEFS.map((def) => ({
    ...def,
    items: sortGuideRows(
      functionGuideList.filter((row) => rowTypeKey(row) === def.type)
    )
  }))
}

export function getFirstGuideItem(functionGuideList) {
  const columns = buildGuideColumns(functionGuideList)
  for (const col of columns) {
    if (col.items.length) {
      return col.items[0]
    }
  }
  return null
}
